var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusSeatGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6D273",
    stroke: "#7BA848",
    strokeWidth: 0.5,
    d: "M1.037 14.286V4.511c0-1.227.981-2.221 2.192-2.221h9.07c1.21 0 2.192.994 2.192 2.221v9.775c0 1.226-.981 2.22-2.192 2.22H3.23c-1.21 0-2.192-.993-2.192-2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C2",
    d: "M14.05 3.736H7.613a.608.608 0 01-.614-.6V1.184c0-.332.275-.6.614-.6h8.772c.339 0 .614.268.614.6v15.59-.007.216c0 .332-.275.6-.614.6H7.614a.607.607 0 01-.614-.6v-1.952c0-.331.275-.6.614-.6h6.435V3.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7BA848",
    stroke: "#7BA848",
    strokeWidth: 0.75,
    d: "M14.05 3.736H7.613a.608.608 0 01-.614-.6V1.184c0-.332.275-.6.614-.6h8.772c.339 0 .614.268.614.6v15.59-.007.216c0 .332-.275.6-.614.6H7.614a.607.607 0 01-.614-.6v-1.952c0-.331.275-.6.614-.6h6.435V3.736z"
  }))));
}
export default SvgBusSeatGreen;